// // We need jQuery
// var $ = window.jQuery;

// export default {
//   loaded() {
//     var productUrls = $('#import-bar').data('urls');
//     var productComplete = 0
//     console.log(productUrls.length);
    
//     for(var i = 0; i < productUrls.length; i ++) {
//       $.ajax({
//         url: tofinoJS.ajaxUrl,
//         type: 'POST',
//         data: {
//           action: 'downloadProduct',
//           value: {
//             product_url: productUrls[i]
//           }
//         },
//         dataType: 'json'
//       })
//       .done(function (response) {
//         console.log(response);
//         productComplete += 1;
//         $('#import-bar .done').css('right', 100 - (productComplete / productUrls.length * 100) + '%')

//       })
//     }
//   }
// };
